import React, {Component} from 'react';
import {FormGroup, Input as RBInput} from 'reactstrap'

import styles from './Input.css'

export default class Input extends Component {
    render() {

        const {type, name, placeholder, value, onChange, error, light} = this.props;

        return (
            <FormGroup className={[styles.input, styles.formGroup, error ? styles.error : "", light ? styles.light : ""].join(' ')}>
                <RBInput
                    type={type}
                    name={name}
                    id={name}
                    placeholder={placeholder}
                    autocomplete="off"
                    value={value}
                    onChange={onChange}
                />
            </FormGroup>
        )

    }
}



// WEBPACK FOOTER //
// ./src/components/Input/Input.js